import React, { useEffect, useState, forwardRef } from 'react';
import styled, { keyframes, Keyframes } from 'styled-components'


import { createRoomMovement } from '../utils/roomHelpers'

const Scroller = forwardRef<HTMLDivElement, any>(({ children }, ref) => {
	const [BrowserSupport, setBrowserSupport] = useState(true);

  useEffect(() => {
    const checkBrowser = () => {
      var isFirefox = typeof InstallTrigger !== 'undefined';
      if(isFirefox){setBrowserSupport(false)};
    }

    checkBrowser();
  }, [])

	return(
		<StyledScroller ref={ref} className={!BrowserSupport ? "browserFix" : ""}>{children}</StyledScroller>
	)
})

export default Scroller;

const StyledScroller = styled.div`
	height: 100%;
	transform-style: preserve-3d;

	//transform:translateZ(-500px);

	&.browserFix{
		height:auto;
	}
`